import { AnyAction } from "redux";
import {
  AccessRequestPayload,
  UpdateAccessPayload,
  User,
  UserDetail,
} from "../../types/auth.types";

export const GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN";
export const GET_ACCESS_TOKEN_SUCCESS = "GET_ACCESS_TOKEN_SUCCESS";
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const GET_USER_DETAILS_SUCCESS = "GET_USER_DETAILS_SUCCESS";
export const GET_USER_DETAILS_ERROR = "GET_USER_DETAILS_ERROR";
export const OPEN_ACCESS_REQUEST_MODAL = "OPEN_ACCESS_REQUEST_MODAL";
export const SEND_USER_REQUEST = "SEND_USER_REQUEST";
export const SEND_USER_REQUEST_SUCCESS = "SEND_USER_REQUEST_SUCCESS";
export const ADD_USER_REQUEST_SUCCESS = "ADD_USER_REQUEST_SUCCESS";
export const SEND_USER_REQUEST_ERROR = "SEND_USER_REQUEST_ERROR";
export const UPDATE_ACCESS = "UPDATE_ACCESS";
export const UPDATE_ACCESS_SUCCESS = "UPDATE_ACCESS_SUCCESS";
export const UPDATE_ACCESS_ERROR = "UPDATE_ACCESS_ERROR";
export const DELETE_ACCESS = "DELETE_ACCESS";
export const DELETE_ACCESS_SUCCESS = "DELETE_ACCESS_SUCCESS";
export const DELETE_ACCESS_ERROR = "DELETE_ACCESS_ERROR";

export interface IAuthReducer {
  isLoading: boolean;
  isLoggedIn: boolean;
  accessToken: string | null;
  user: User | null;
  isOpenAccessRequestModal: boolean;
  isLoadingUserDetails: boolean;
  userDetails: UserDetail[];
  isRequestingUserAccess: boolean;
  accessRequestError: string | null;
  isUpdatingUserAccess: string | null;
  isDeletingUserAccess: string | null;
}

export const getAccessToken = () => ({
  type: GET_ACCESS_TOKEN,
});

export const gotAccessToken = (value: string) => ({
  type: GET_ACCESS_TOKEN_SUCCESS,
  value,
});

export const gotUserDetail = (value: User | null) => ({
  type: GET_USER_DETAIL_SUCCESS,
  value,
});

export const fetchUserDetails = () => ({
  type: GET_USER_DETAILS,
});

export const fetchUserDetailsSuccess = (value: UserDetail[]) => ({
  type: GET_USER_DETAILS_SUCCESS,
  value,
});

export const fetchUserDetailsError = () => ({
  type: GET_USER_DETAILS_ERROR,
});

export const openAccessRequestModal = (value: boolean) => ({
  type: OPEN_ACCESS_REQUEST_MODAL,
  value,
});

export const sendRequest = (
  insideRequestModal: boolean,
  data: AccessRequestPayload
) => ({
  type: SEND_USER_REQUEST,
  value: { insideRequestModal, data },
});

export const sendRequestSuccess = () => ({
  type: SEND_USER_REQUEST_SUCCESS,
});

export const addUserRequestSuccess = (value: UserDetail) => ({
  type: ADD_USER_REQUEST_SUCCESS,
  value,
});

export const sendRequestError = (value: string) => ({
  type: SEND_USER_REQUEST_ERROR,
  value,
});

export const updateAccess = (value: UpdateAccessPayload) => ({
  type: UPDATE_ACCESS,
  value,
});

export const updateAccessSuccess = (value: UpdateAccessPayload) => ({
  type: UPDATE_ACCESS_SUCCESS,
  value,
});

export const updateAccessError = () => ({
  type: UPDATE_ACCESS_ERROR,
});

export const deleteAccess = (value: string) => ({
  type: DELETE_ACCESS,
  value,
});

export const deleteAccessSuccess = (value: string) => ({
  type: DELETE_ACCESS_SUCCESS,
  value,
});

export const deleteAccessError = () => ({
  type: DELETE_ACCESS_ERROR,
});

export const initialState: IAuthReducer = {
  isLoading: false,
  isLoggedIn: false,
  accessToken: null,
  user: null,
  isOpenAccessRequestModal: false,
  isLoadingUserDetails: false,
  userDetails: [],
  isRequestingUserAccess: false,
  accessRequestError: null,
  isUpdatingUserAccess: null,
  isDeletingUserAccess: null,
};

export const authReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case GET_ACCESS_TOKEN:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ACCESS_TOKEN_SUCCESS:
      const accessToken = action.value;
      return {
        ...state,
        accessToken,
      };
    case GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: true,
        user: action.value,
      };
    case GET_USER_DETAILS:
      return {
        ...state,
        isLoadingUserDetails: true,
      };
    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.value,
        isLoadingUserDetails: false,
      };
    case GET_USER_DETAILS_ERROR:
      return {
        ...state,
        userDetails: [],
        isLoadingUserDetails: false,
      };
    case OPEN_ACCESS_REQUEST_MODAL:
      return {
        ...state,
        isOpenAccessRequestModal: action.value,
      };
    case SEND_USER_REQUEST:
      return {
        ...state,
        isRequestingUserAccess: true,
        accessRequestError: null,
      };
    case SEND_USER_REQUEST_SUCCESS:
      return {
        ...state,
        isRequestingUserAccess: false,
        accessRequestError: null,
      };
    case ADD_USER_REQUEST_SUCCESS:
      return {
        ...state,
        userDetails: [action.value, ...state.userDetails],
      };
    case SEND_USER_REQUEST_ERROR:
      return {
        ...state,
        isRequestingUserAccess: false,
        accessRequestError: action.value,
      };
    case UPDATE_ACCESS:
      return {
        ...state,
        isUpdatingUserAccess: action.value.id,
      };
    case UPDATE_ACCESS_SUCCESS:
      return {
        ...state,
        userDetails: state.userDetails.map((user) =>
          user.id === action.value.id
            ? {
                ...user,
                ...action.value,
              }
            : user
        ),
        isUpdatingUserAccess: null,
      };
    case UPDATE_ACCESS_ERROR:
      return {
        ...state,
        isUpdatingUserAccess: null,
      };
    case DELETE_ACCESS:
      return {
        ...state,
        isDeletingUserAccess: action.value,
      };
    case DELETE_ACCESS_SUCCESS:
      return {
        ...state,
        userDetails: state.userDetails.filter(
          (user) => user.id !== action.value
        ),
        isDeletingUserAccess: null,
      };
    case DELETE_ACCESS_ERROR:
      return {
        ...state,
        isDeletingUserAccess: null,
      };
    default:
      return state;
  }
};

export default authReducer;
